<template lang="pug">
div.boxSectionHeaderAndBody
  div#navtop(:class="{'anchoEscritorioSubnavCerrado': subNavClosed}")
    div.sectionmenu
      div.firstlevel.d-flex.justify-space-between
        div
          router-link( :to="{name: 'IAReputationReputation', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Reputation]
          router-link( :to="{name: 'IAReputationVisibility', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Visibility]
          router-link( :to="{name: 'IAReputationGoogleAIAlignment', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Google AI Alignment]
          router-link(:to="{name: 'IAReputationTopics', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Topics]
          router-link( :to="{name: 'IAReputationPrompts', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Prompts]
          router-link( :to="{name: 'IAReputationSources', params: {paramCOD: this.paramCOD}, query: queryParams}") #[translate Sources]

        select-country-and-logout
  div.gridSection
    div.sectionmenu
      <div v-if=brandHasIAReputation class="mainIAReputation" id="ia">
        router-view
      </div>
      <div class="mainIAReputation" v-else>
        <div class="box">
          <span class="titleBoxIa"><translate>Servicio IA Reputation no contratado</translate></span>
          <p>Para ver los datos de reputación de esta marca, necesitas contratar el módulo de IA Reputation.</p>
        </div>
      </div>

</template>

<script>
import FiltersAndBreadCrumb from "@/components/filters/filtersAndBreadCrumb.vue"
import * as types from '@/store/mutation-types'
import commonMixins from "@/mixins/common.js"
import WarningNotDeliveryNotInternet from '@/components/common/WarningNotDeliveryNotInternet.vue'
import SelectCountryAndLogout from "@/components/common/SelectCountryAndLogout.vue"
import brandMixin from '@/mixins/brand.js'
import Breadcrumbs from "@/components/common/Breadcrumbs.vue"
import MixinIAReputation from "@/mixins/iareputation.js"

export default {
  props: ['paramCOD', 'type', 'site', 'typeRestaurant', 'after', 'before'],
  mixins: [commonMixins, brandMixin, MixinIAReputation],
  components: { FiltersAndBreadCrumb, WarningNotDeliveryNotInternet, SelectCountryAndLogout, Breadcrumbs },
  created() {
    this.$store.commit(types.UPDATE_SECTION, 10)
    this.loadUrlParams()
  },
  watch: {
    filterForSites: function () {
      this.$store.dispatch('getSitesOpinions')
    },
  },
  computed: {
    config_app () {
      return this.$config
    },
    brandHasIAReputation () {
      // si api tiene healthypoke y el nodo de la marca es tal si tienen
      if (this.$config.api.indexOf('healthypoke') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeHealthyPoke) {
        return true
      }
      //IBERSOL PANS COMPANY
      if (this.$config.api.indexOf('ibersol') > -1 && parseInt(this.$store.getters.getNode) === this.idNodePansCompany) {
        return true
      }
      //RIBS
      if (this.$config.api.indexOf('ibersol') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeRibs) {
        return true
      }
      //IL CORTILE
      if (this.$config.api.indexOf('gastroagencia') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeIlCortile) {
        return true
      }
      //CAN PIZZA
      if (this.$config.api.indexOf('cex') > -1 && parseInt(this.$store.getters.getNode) === this.idNodeCanPizza) {
        return true
      }
      return false
    }
  }
}
</script>
<style>
.mainIAReputation{
  padding: 22px 13px 22px 27px;
  background-color: #F2F2F2;
}
</style>

